import { ATBeaconLoadingSpinner } from 'components/common/beacon/beaconRegistration';
import React from 'react';

const PershingSpinner: React.FC = () => (
  <p className="layout-section pershing-loader">
    <ATBeaconLoadingSpinner scale={'jumbo'} />
    <label className="b-typography-serif--headline--500 b-font-weight-bold error-message">
      Submission is in progress
    </label>
    <label className="b-typography-sans-serif--body--100 b-font-weight-light">
      Please note it can take up to a minute to complete submission.
    </label>
  </p>
);

export default PershingSpinner;
